<template>
    <div class="anser-button" :style="{ bottom }">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        bottom: String,
    },
};
</script>

<style lang="scss" scoped>
.anser-button {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: center;
    img {
        cursor: pointer;
        display: block;
        width: 20%;
        height: auto;
        &:first-child {
            margin-right: 100px;
        }
    }
}
</style>
